module.exports = __webpack_public_path__ + "img/gp_main01_text.ec2a6c1f.svg";